import styled from "styled-components";

export const StyledVideoModal = styled.div``;
